import { Navbar } from "@/components/Navbar";
import { useEffect } from "react";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Philosophy } from "@/components/Philosophy";
import { Chronicle } from "@/components/Chronicle";
import { Signature } from "@/components/Signature";
import { Services } from "@/components/Services";
import { Method } from "@/components/Method";
import { Gallery } from "@/components/Gallery";
import { Testimonials } from "@/components/Testimonials";
import { Manifesto } from "@/components/Manifesto";
import { Consultation } from "@/components/Consultation";
import { Newsletter } from "@/components/Newsletter";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Transmission } from "@/components/Transmission";
import { Prelude } from "@/components/Prelude";

export default function Home() {
  useEffect(() => {
    if (!window.location.hash) return;
    const id = window.location.hash;
    const scroll = () => document.querySelector(id)?.scrollIntoView({ behavior: "auto" });
    const t1 = setTimeout(scroll, 300);
    const t2 = setTimeout(scroll, 1200);
    const t3 = setTimeout(scroll, 2500);
    window.addEventListener("load", scroll);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      window.removeEventListener("load", scroll);
    };
  }, []);

  return (
    <div data-testid="home-page" className="bg-[#0A1420] text-white">
      <Prelude />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Philosophy />
        <Chronicle />
        <Transmission />
        <Signature />
        <Services />
        <Method />
        <Gallery />
        <Testimonials />
        <Manifesto />
        <Consultation />
        <Newsletter />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
